import { create } from 'zustand';

export const STEPS = [
  'enter-email',
  'sign-up/fill-name',
  'sign-up/how-did-you-hear-about-us',
  'sign-up/what-do-you-want-to-sell',
  'confirm-email',
];

interface SignUpState {
  email: string;
  firstName: string;
  lastName: string;
  referralSource: string;
  salesModel: string;
  referrer: string;
  other: string;
  token: string;
  profileInstagram: string;
  setEmail: (email: string) => void;
  setFirstName: (firstName: string) => void;
  setLastName: (lastName: string) => void;
  setReferrer: (referrer: string) => void;
  setOther: (other: string) => void;
  setReferralSource: (howDidYouHearAboutUs: string) => void;
  setSalesModel: (salesModel: string) => void;
  setToken: (token: string) => void;
  setProfileInstagram: (profileInstagram: string) => void;
}

export const useSignUpStore = create<SignUpState>((set) => ({
  email: '',
  firstName: '',
  lastName: '',
  referralSource: '',
  referrer: '',
  salesModel: 'subscription',
  other: '',
  token: '',
  profileInstagram: '',
  setProfileInstagram: (profileInstagram) => set({ profileInstagram }),
  setEmail: (email) => set({ email }),
  setFirstName: (firstName) => set({ firstName }),
  setLastName: (lastName) => set({ lastName }),
  setReferralSource: (howDidYouHearAboutUs) => {
    set({ referralSource: howDidYouHearAboutUs });
  },
  setSalesModel: (salesModel) => set({ salesModel }),
  setReferrer: (referrer) => set({ referrer }),
  setOther: (other) => set({ other }),
  setToken: (token) => set({ token }),
}));
